import React from "react";
import {Tooltip as ReactTooltip} from "react-tooltip";
import {useTheme} from 'react-jss';

const TooltipPopup = ({ parent, clickable }) => {
  const click = clickable ? true : false;
  const theme = useTheme();
  return (
    <>
      <ReactTooltip
        id={parent ? parent + "bottom" : "bottom"}
        clickable={click}
        multiline
        place="bottom"
        style={{
          backgroundColor: theme.tooltipDarkBackgroundColor,
          color: theme.tooltipDarkColor,
        }}
      />
      <ReactTooltip
        id={parent ? (parent === "stim2" ? "stim2" : parent + "top") : "top"}
        clickable={click}
        multiline
        place="top"
        style={{
          backgroundColor: theme.tooltipDarkBackgroundColor,
          color: theme.tooltipDarkColor,
        }}
      />
      <ReactTooltip
        id={parent ? parent + "left" : "left"}
        clickable={click}
        multiline
        place="left"
      />
      <ReactTooltip
        id={parent ? parent + "right" : "right"}
        clickable={click}
        multiline
        place="right"
      />
    </>
  );
  };
  
  export default TooltipPopup;
  